
import PlaceCategoryMixin from "@/mixins/filter-genre.mixin";
import { PropType } from "vue";
import { DataType } from "./@types/place-category.d";
import Vue2Filters from "vue2-filters";
import GenreBtn from "@/components/genre-place-category/place-category-genre-btn.vue";
import { mapState } from "vuex";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export default PlaceCategoryMixin.extend({
  name: "component-place-category-normal-genre",
  mixins: [Vue2Filters.mixin, PlaceCategoryMixin],
  components: { GenreBtn },
  props: {
    onlyShowInJapan: Boolean,
    placeCategoryList: {
      type: Array as PropType<DataType["placeCategoryList"]>,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapState("data", ["selectedGenre"]),
    orderPlaceCategoryList(): PortalAdapterApi.ResponseGetPlaceCategoryList {
      return Vue2Filters.mixin.methods.orderBy(this.placeCategoryList, "displayOrder");
    },
  },
  methods: {
    rowClicked(genreName: string) {
      this.$emit("genre-clicked", genreName);
    },
    doNotShowPollAndEvacuation(cat: PortalAdapterApi.PlaceCategory): boolean {
      return cat.placeCategoryType !== "polling-place" && cat.placeCategoryType !== "evacuation-center";
    },
  },
});
